import { EditorView } from 'prosemirror-view';

import { MentionServiceInternal } from './mentions-service-internal';

export class MentionsServicePublic {
  private preferredPickerPositions = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' } as const,
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' } as const,
  ];

  constructor(
    private editorView: EditorView,
    private mentionServiceInternal: MentionServiceInternal,
  ) {}

  public mentionsWithSearchOpen(origin: HTMLElement) {
    const { from, to } = this.editorView.state.selection;
    const position = origin.getBoundingClientRect();

    this.mentionServiceInternal.currentOrigin = origin;
    this.mentionServiceInternal.openMentionsList(position, {
      withSearch: true,
      preferredPositions: this.preferredPickerPositions,
      queryChange: (value: string) => {
        const filteredData = this.mentionServiceInternal.filterData(value);
        this.mentionServiceInternal.updateMentionListData(from, to, filteredData);
      },
    });
    this.mentionServiceInternal.updateMentionListData(from, to, this.mentionServiceInternal.data);
  }
}
